import { render, staticRenderFns } from "./SettingsDropdown.vue?vue&type=template&id=92f86baa"
import script from "./SettingsDropdown.vue?vue&type=script&lang=ts"
export * from "./SettingsDropdown.vue?vue&type=script&lang=ts"
import style0 from "./SettingsDropdown.vue?vue&type=style&index=0&id=92f86baa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports